import { EmphasisBanner } from '@abyss/web/ui/EmphasisBanner/V2EmphasisBanner';
import { find } from 'lodash';
import React from 'react';

import {
  getClientPortalConfig,
  getGuestThemeColors,
} from '../../frontends/GuestExperience/utils';
import { useLagoon } from '../../hooks/useLagoon';
import { Constants } from '../Constants';
import { ConstantsLagoon } from '../ConstantsLagoon';

interface UHCSignInBannerProps {
  signInConfig: {
    url?: string;
  };
}

export const UHCSignInBanner: React.FC<UHCSignInBannerProps> = ({
  signInConfig,
}) => {
  const clientName = sessionStorage.getItem(
    Constants.STORAGE_KEYS.SESSION.CLIENT_NAME
  );
  const clientPortalConfig = getClientPortalConfig(clientName);
  const theme = getGuestThemeColors(clientPortalConfig.themeOverride);

  const lagoonUIMessage = useLagoon('ui-messaging')();
  const signInBannerText = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.UHC_MEMBER_SIGN_IN_TEXT,
  }).message;
  const signInBannerMessage = find(lagoonUIMessage, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION.UHC_MEMBER_SIGN_IN_MESSAGE,
  }).message;

  return (
    <EmphasisBanner
      color="emphasis4"
      cta={{
        link: {
          children: 'Sign in',
          href: signInConfig.url || '#',
          openNewWindow: false,
          css: {
            'abyss-link-icon': {
              display: 'none',
            },
            'abyss-link-insert-element-after': {
              display: 'none',
            },
            'abyss-link-root': {
              borderRadius: '500px',
              fontSize: '14px',
              backgroundColor: theme.primaryColor,
              color: '#ffffff',
              padding: '8px 16px',
              fontWeight: 700,
              whiteSpace: 'nowrap',
              '&:hover': {
                color: '#ffffff',
                textDecoration: 'none',
                backgroundColor: '#196ECF',
              },
            },
          },
        },
      }}
      data-auto-testid="uhc-sign-in-banner"
      data-testid="uhc-sign-in-banner"
      dismissible={false}
      iconBrand={{ icon: 'care' }}
      title={signInBannerText}
    >
      {signInBannerMessage}
    </EmphasisBanner>
  );
};
